import * as Sentry from '@sentry/react';
import { env } from 'features/env';
import type { ErrorReportingUser } from 'features/error-reporting/errorReportingUser';

const RUNNING_LOCALLY = window.location.hostname === 'localhost';
const SENTRY_ENABLED_FROM_ENV = process.env.REACT_APP_ENABLE_SENTRY === 'true';

// URLs/domains to send tracingheaders Sentry-Trace & Baggage to
const tracePropagationTargets = [env.REACT_APP_API_URL_DATAENTRY];

if (SENTRY_ENABLED_FROM_ENV && !RUNNING_LOCALLY) {
	Sentry.init({
		environment: process.env.REACT_APP_ENVIRONMENT,
		dsn: 'https://1870ca38c3bf0884489aba07593cad61@o4508063937527808.ingest.de.sentry.io/4508068944674897',
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
			Sentry.captureConsoleIntegration({
				levels: ['error', 'warn']
			}),
			Sentry.extraErrorDataIntegration({ depth: 4 })
		],
		ignoreErrors: [/^canceled$/],
		release: process.env.REACT_APP_VERSION,
		// Tracing
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		tracePropagationTargets,
		// Session Replay
		replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	});
}

export const configureSentryUser = ({ userId, sessionId, deviceId }: ErrorReportingUser) => {
	Sentry.setUser({
		id: userId,
		...(sessionId ? { session_id: sessionId } : {}),
		...(deviceId ? { device_id: deviceId } : {})
	});
};

export const logWithDetails = (error: unknown, details: unknown) => {
	Sentry.withScope(scope => {
		scope.setExtra('details', details);
		Sentry.captureException(error);
	});
};
